/**
 * Testimonial slider: prev/next, wrap, prefers-reduced-motion, theme editor safe init.
 */
function prefersReducedMotion() {
  return typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function initTestimonialSlider(root) {
  if (!root || root.dataset.testimonialSliderInit === '1') return;
  root.dataset.testimonialSliderInit = '1';

  const track = root.querySelector('[data-testimonial-track]');
  const prev = root.querySelector('[data-testimonial-prev]');
  const next = root.querySelector('[data-testimonial-next]');
  const slides = root.querySelectorAll('[data-testimonial-slide]');
  const count = slides.length;

  if (!track || !prev || !next || count === 0) return;

  let index = 0;

  const applyTransition = () => {
    track.style.transition = prefersReducedMotion() ? 'none' : 'transform 0.45s ease';
  };

  const setTransform = () => {
    track.style.transform = 'translateX(-' + index * 100 + '%)';
  };

  const syncA11y = () => {
    slides.forEach((slide, i) => {
      slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      slide.setAttribute('tabindex', i === index ? '0' : '-1');
    });
    const single = count <= 1;
    prev.disabled = single;
    next.disabled = single;
    prev.setAttribute('aria-hidden', single ? 'true' : 'false');
    next.setAttribute('aria-hidden', single ? 'true' : 'false');
  };

  const go = (delta) => {
    if (count <= 1) return;
    index = (index + delta + count) % count;
    applyTransition();
    setTransform();
    syncA11y();
  };

  applyTransition();
  setTransform();
  syncA11y();

  prev.addEventListener('click', () => go(-1));
  next.addEventListener('click', () => go(1));

  window.addEventListener('resize', applyTransition);
}

function initAllTestimonialSliders() {
  document.querySelectorAll('[data-testimonial-slider]').forEach(initTestimonialSlider);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllTestimonialSliders);
} else {
  initAllTestimonialSliders();
}

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target;
  if (section && section.querySelectorAll) {
    section.querySelectorAll('[data-testimonial-slider]').forEach(initTestimonialSlider);
  }
});
